module.exports = require("http");


/*****************
 ** WEBPACK FOOTER
 ** external "http"
 ** module id = 266
 ** module chunks = 0
 **/